/* src/app/views/admin/doctors/doctors.component.css */
::ng-deep p-paginator svg {
  transform: rotate(180deg);
}
/*# sourceMappingURL=doctors.component.css.map */
